module.exports = __webpack_public_path__ + "img/ml.99ff04e5.svg";